<template>
  <div class="join-box">
    <div class="join-top">
      <el-image 
        class="banner-image hidden-lg-and-down"
        lazy 
        :src="base_image_url + '/images/join-banner.png'" 
        onerror="../../assets/image/loadimg/join-banner.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/join-banner.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image hidden-xl-only hidden-sm-only hidden-xs-only"
        lazy 
        :src="base_image_url + '/images/join-banner-md.png'" 
        onerror="../../assets/image/loadimg/join-banner-md.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/join-banner-md.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image hidden-xl-only hidden-lg-only hidden-md-only  hidden-xs-only"
        lazy 
        :src="base_image_url + '/images/join-banner-sm.png'" 
        onerror="../../assets/image/loadimg/join-banner-sm.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/join-banner-sm.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only"
        lazy 
        :src="base_image_url + '/images/join-banner-xs.png'" 
        onerror="../../assets/image/loadimg/join-banner-xs.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/join-banner-xs.jpg" alt="">
        </div>
      </el-image>
      <div class="join-top-content">
        <div class="join-img flex-center">
          <img class="hidden-xs-only" src="../../assets/image/we-need-you.png" alt="">
          <img class="hidden-sm-and-up" src="../../assets/image/we-need-you.png" alt="">
        </div>
        <p class="join-desc">这里有极客，有大牛，更有值得你奋斗的事业；加入 RenderG，在下一部大片中，留下自己的足迹</p>
      </div>
    </div>
  </div>
</template>

<script>
import { base_image_url } from '@/constants/baseUrl'
export default {
  name: 'Join',
  computed: {
    base_image_url() {
      return base_image_url
    }
  },
}

</script>